import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PRICING_PAGE_PATH } from '../shared/constants';
import { PricingComponent } from './pricing.component';

const routes: Routes = [
  {
    path: PRICING_PAGE_PATH,
    component: PricingComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PricingRoutingModule {}
